export const SET_COUNT_ORDERS = 'SET_COUNT_ORDERS';
export const SET_NEW_ORDERS_FLAG = 'SET_NEW_ORDERS_FLAG';
export const SET_ORDERS_CHANGED_FLAG = 'SET_ORDERS_CHANGED_FLAG';
